module.exports = __webpack_public_path__ + "img/brand-icon11.d1c6a40d.png";